import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as registrationActions from '../../actions/registration';
import { Link } from 'react-router-dom';
import Header from '../Header';
import { scpClient } from '../../constants/SiteVariables';

class Confirm extends React.Component {
  state = {
    code: {}
  }

  componentWillMount() {
    this.props._registration.getAccessCodeDetails()
      .then(res => this.setState({ code: res }));
  }

  redirect = () => {
    window.location.href = scpClient() + '?access_token=' + this.props.auth.get('user').get('access_token');
  }

  render() {
    if (!this.state.code.code) return <div>loading</div>;

    let scales = [];
    if (this.state.code.visits.length > 0) {
      this.state.code.visits[0].scales.forEach((s, i) => scales.push(<li style={{ listStyleType: 'circle', marginLeft: '20px' }} key={i}>{s.long_name}</li>))
    }

    return (
     <section>
      <Header {...this.props} /> 
      <div className="container has-text-centered">
       <section className="section">
          <div className="container">
            <h1 className="title is-3" style={{ marginBottom: '3rem' }}>Account Confirmation</h1>
            <p className="content" style={{ fontWeight: 'bold' }}>Congratulations, your Engaged Practice Self Care Partner account is ready to go!</p>
            {this.state.code.visits.length > 0 && <div className="columns">
              <div className="column has-text-left">
                <h4 className="is-4 subtitle">Next Steps</h4>
                <p>Get started by logging into the Self Care Partner site with your email address and password that you just created.</p>
                <div className="has-text-centered" style={{ marginTop: '20px' }}>
                  <button className="button is-large is-golden" onClick={this.redirect}>Get Started</button>
                </div>
              </div>
              <div className="column has-text-left">
                <h4 className="is-4 subtitle">Details for {this.props.registration.get('access_code')}</h4>
                <p>Your account has been configured with {this.state.code.visits.length} visits.</p>
                <p>The first visit is the <strong>{this.state.code.visits[0].name}</strong> visit and will guide you through the following assessments:</p>
                <ul>
                  {scales}
                </ul>
              </div>
            </div>}
          </div>
        </section>          
      </div>
    </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    registration: state.registration
  };
}

function mapDispatchToProps(dispatch) {
  return {
    _registration: bindActionCreators(registrationActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Confirm);



// WEBPACK FOOTER //
// ./src/components/pages/Confirm.js